import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../parseError';
import { Toast } from '../../../../../../Notification';

const createTourActivityFlag = async ({ state, userId, addTourActivityFlag, updateState, refreshPage }) => {
  const { resource, itemDetails } = state;
  const { tourId, activityFlagId, jobElementId, tourActivityFlagStartTime, tourActivityFlagEndTime } = itemDetails;
  let parameters = {
    tourId,
    activityFlagId,
    jobElementId: jobElementId || 0,
    startTime: tourActivityFlagStartTime.format('YYYY-MM-DD HH:mm:SS'),
    endTime: tourActivityFlagEndTime.format('YYYY-MM-DD HH:mm:SS'),
    updatingUserId: userId
  };
  const day = moment(tourActivityFlagStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Activity Flag Added', description: `For ${resource.name} on ${day}`};
  try {
    await addTourActivityFlag(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'addTourActivityFlag',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Adding Activity Flag Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default createTourActivityFlag;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/tour/activityFlag/createTourActivityFlag.js